(function ($) {
    var $stickyElement = $(".social-icon-wrapper.isSticky"),
        $boundaryElement = $(".contentbox-artikel"),
        stickyOffsetTop = -10;

    if ($stickyElement.length) {
        $(window).on("resize scroll", function () {
            var stickyElementHeight = $stickyElement.outerHeight(true),
                stickyStart = $boundaryElement[0].getBoundingClientRect().top + stickyOffsetTop,
                stickyStop = $boundaryElement[0].getBoundingClientRect().bottom  - (stickyElementHeight * 2);

            if (stickyStart > 0) {
                $stickyElement
                    .removeClass("sticky")
                    .removeClass("after-sticky")
                    .addClass("before-sticky");
            }
            else if (stickyStart <= 0 && stickyStop > 0) {
                $stickyElement
                    .removeClass("before-sticky")
                    .removeClass("after-sticky")
                    .addClass("sticky");
            }
            else {
                $stickyElement
                    .removeClass("before-sticky")
                    .removeClass("sticky")
                    .addClass("after-sticky");
            }
        });
    }
})(jQuery);
